module.exports = __webpack_public_path__ + "static/media/0.95b7a5c3.jpg";